import React, { useContext, useState } from 'react';
import { ExportToCsv } from 'export-to-csv';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { FaFileExport, FaFileImport, FaCloudUploadAlt, FaTimes } from 'react-icons/fa';

import { ToastSuccess, ToastError } from '../functions/ToastShow';

import { BASE_URL } from '../BaseUrl';
import { SettingsContext } from '../contexts/Settings';
import { _t, getCookie } from '../functions/Functions';

const CsvImportExport = (props) => {

  const { t } = useTranslation();
  const { loading, setLoading, setDataPaginating } = useContext(SettingsContext);

  const {
    filename = "PR",
    csvLength = 6,
    exportUrl = "",
    importUrl = "",
    exportBtnName = "Export CSV",
    csvData = [],
    onCsvResponse = () => { }
  } = props


  //csv
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: filename,
  };

  const csvExporter = new ExportToCsv(options);
  const [uploadCsv, setUploadCsv] = useState(null);

  const [uploadCsvModal, setUploadCsvModal] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [fileName, setFileName] = useState("");

  //csv
  const handleExportCsv = () => {
    setDataPaginating(true);
    const url = BASE_URL + exportUrl;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        csvExporter.generateCsv(res.data);
        setDataPaginating(false);
      })
      .catch(() => {
        setDataPaginating(false);
        ToastError({ title: t("Please try again") });
      });
  }

  // Check if the uploaded content is in valid CSV format
  function isCSV(contents) {
    // Basic check if it's a CSV file by checking if it contains a comma
    const rows = contents.split('\n');

    // Extract the header row (assuming it's the first row)
    const headerRow = rows[0];

    // Split the header row into individual header values
    const headers = headerRow.split(',');
    return contents.includes(',') && contents.includes('\n') && (headers.length === csvLength);
  }

  // Handle file processing
  const processFile = (file) => {
    if (!file) return;

    setFileName(file.name);
    const fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onload = (e) => {
      const contents = e.target.result;
      if (isCSV(contents)) {
        const startIndex = 1; // Start index
        const lines = contents.trim().split('\n').slice(startIndex);
        const parsedData = lines.map((line) => {
          const values = line.split(',').map(value => value.replace(/["/\r\n]/g, ''));
          const obj = {};
          csvData && csvData.forEach((data, index) => {
            obj[data.key] = values[index];
          });
          return obj;
        })
        setUploadCsv(parsedData);
      } else {
        setUploadCsv(null);
        setFileName("");
        if (document.getElementById('uploadFile')) {
          document.getElementById('uploadFile').value = '';
        }
        ToastError({ title: t("Please upload a valid CSV file to continue") });
      }
    };
  };

  // Handle file selection from input
  const handleOnChange = (e) => {
    if (e.target.files[0]) {
      processFile(e.target.files[0]);
    };
  }

  // Handle Drag & Drop
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      processFile(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  const removeFile = () => {
    setUploadCsv(null);
    setFileName("");
    if (document.getElementById('uploadFile')) {
      document.getElementById('uploadFile').value = '';
    }
  };
  
  // Submit the parsed CSV data to the server
  const handleCsvSubmit = (e) => {

    e.preventDefault();

    const url = BASE_URL + importUrl;

    let formData = {
      items: uploadCsv
    }

    if (!uploadCsv || uploadCsv.length === 0) {
      ToastError({ title: t("Please upload file") });
      return false
    }

    setLoading(true);
    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        removeFile();
        setUploadCsvModal(false);
        setLoading(false);

        if (res.data?.successful_identities) {
          ToastSuccess({ title: t(res.data.successful_identities) });
          return

        }

        if (res.data) {
          onCsvResponse(res.data)
        }

        ToastSuccess({ title: t("File uploaded successfully") });

      })
      .catch((err) => {
        setLoading(false);
        removeFile();
        if (err.response.data?.status === "error") {
          ToastError({ title: t(err.response.data?.message || "Please try again") });
        } else {
          ToastError({ title: t("Please try again") });
        }
      });

  }


  return (
    <>
      {/*upload csv Modal*/}
      <div
        className={`modal fade ${uploadCsvModal !== false ? "showing" : ""
          }`}
        id="addReason"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">Import CSV</div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  if (document.getElementById('uploadFile')) {
                    document.getElementById('uploadFile').value = '';
                  }
                  if (document.getElementById('uploadFile')) {
                    document.getElementById('uploadFile').value = '';
                  }
                  setUploadCsv(null)
                  setFileName("")
                  setUploadCsvModal(false)
                }}
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form onSubmit={handleCsvSubmit} autoComplete="off">
                  <div>
                    <label htmlFor="name" className="form-label">
                      {_t(t("Upload File"))}{" "}
                      <small style={{ color: "red" }}>*</small>
                    </label>
                    <br />

                    {!uploadCsv ? (
                      <div
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        onClick={() => document.getElementById('uploadFile').click()}
                        style={{
                          border: `2px dashed ${isDragging ? '#28a745' : '#ced4da'}`,
                          borderRadius: '10px',
                          padding: '40px 20px',
                          textAlign: 'center',
                          cursor: 'pointer',
                          backgroundColor: isDragging ? '#e9ecef' : '#f8f9fa',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <FaCloudUploadAlt size={40} color={isDragging ? '#28a745' : '#6c757d'} style={{ marginBottom: '10px' }} />
                        <p className="mb-0 text-muted" style={{ fontWeight: '500' }}>
                          {isDragging ? _t(t("Drop to upload")) : _t(t("Drag & Drop CSV file here or click to browse"))}
                        </p>
                        <input
                          type={"file"}
                          id="uploadFile"
                          name="uploadFile"
                          accept={".csv"}
                          onChange={handleOnChange}
                          style={{ display: 'none' }}
                        />
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-between p-3 border rounded bg-light">
                        <div className="d-flex align-items-center">
                          <FaFileImport className="text-primary mr-3" size={24} />
                          <div>
                            <span className="d-block font-weight-bold">{fileName}</span>
                            <small className="text-muted">{uploadCsv.length} {_t(t("rows found"))}</small>
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm rounded-circle p-1"
                          onClick={removeFile}
                          title={_t(t("Remove file"))}
                          style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          <FaTimes />
                        </button>
                        {/* Hidden input to keep form logic happy if needed, though we handle submit manually */}
                        <input
                          type={"file"}
                          id="uploadFile"
                          name="uploadFile"
                          accept={".csv"}
                          onChange={handleOnChange}
                          style={{ display: 'none' }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="d-flex justify-content-center">
                    <button
                      disabled={loading}
                      type="submit"
                      className="btn btn-primary xsm-text text-uppercase px-3 py-2 my-4 rounded"
                    >
                      {t("Submit")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button title="Download list in excel" className="btn btn-success btn-sm text-uppercase sm-text mr-2 rounded fw-bold" onClick={() => handleExportCsv()} >
          <FaFileExport className="mr-2" />
          {exportBtnName}
        </button>
        <button title="Upload list in excel" className="btn btn-primary btn-sm text-uppercase sm-text mr-2 rounded fw-bold" onClick={() => setUploadCsvModal(true)}>
          <FaFileImport className="mr-2" />
          Import Csv
        </button>
      </div>
    </>
  )
}

export default React.memo(CsvImportExport)